import React from 'react';

const AvailabilityRateTab = ({candidate, position}) => {

    return (
        <div className="proposal-padding">

            {candidate.confirmedStartedAt() && (
                <div className="confirmed-availability-note">
                    <p>
                        The candidate has updated their rate and confirmed availability
                    </p>
                    <p>
                        <small>
                            <b>
                                Last Updated: {TB.moment(candidate.job_candidate.talent_proposal_updated_at).fromNow()}
                            </b>
                        </small>
                    </p>
                </div>
            )}
            <h3 className="proposal-tab-header mt-2">
                Project Rate:
            </h3>
            <p className="proposal-input">
                {!candidate.hasSubmittedProposal() ?
                    'Rate Proposal Pending' :
                    (
                        <span>
                            {candidate.changedHourlyRate() && (
                                <span className="proposed-change">
                                    <span>{candidate.standardPlatformRate()}/hr</span>
                                </span>
                            )}{candidate.proposedPlatformRate()}/hr
                        </span>
                    )
                }
            </p>

            {candidate.job_candidate.platform_cost && (
                <React.Fragment>
                    <h3 className="proposal-tab-header mt-2">
                        Estimated Fee
                    </h3>
                    <p className="proposal-input">
                        <span>
                            {/*{candidate.hasRequestedChangesToAvailability(position) && (*/}
                            {/*    <span className="proposed-change">*/}
                            {/*        <span>{TB.formatCurrency(position.platform_cost)}</span>*/}
                            {/*    </span>*/}
                            {/*)}*/}
                            {TB.formatCurrency(candidate.job_candidate.platform_cost)}
                        </span>
                    </p>
                </React.Fragment>
            )}
            <hr/>

            <h3 className="proposal-tab-header">
                Can Start:
            </h3>
            <p className="proposal-input">
                {!candidate.hasSubmittedProposal() ?
                    'Final Confirmation Pending' :
                    (
                        <span>
                            {candidate.changedStartDate(position) && (
                                <span className="proposed-change">
                                    <span>{TB.moment(position.started_at).format('MM/DD/YYYY')}</span>
                                </span>
                            )}{TB.moment(candidate.job_candidate.confirmed_started_at || position.started_at).format('MM/DD/YYYY')}
                        </span>
                    )
                }
            </p>
            <h3 className="proposal-tab-header">
                Availability
            </h3>
            <p className="proposal-input">
                {!candidate.hasSubmittedProposal() ?
                    'Final Confirmation Pending' :
                    (
                        <span>
                            {candidate.changedAvgHoursPerWeek(position) && (
                                <span className="proposed-change">
                                    <span>{position.avg_hours_per_period} hrs per week</span>
                                </span>
                            )}{candidate.job_candidate.confirmed_avg_hours_per_period} hrs per week
                        </span>
                    )
                }
            </p>
        </div>
    );
};

export default AvailabilityRateTab;